var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 56C42 53.8256 42 52.7384 42.3552 51.8808C42.8289 50.7373 43.7373 49.8289 44.8808 49.3552C45.7384 49 46.8256 49 49 49H63C65.1744 49 66.2616 49 67.1192 49.3552C68.2627 49.8289 69.1711 50.7373 69.6448 51.8808C70 52.7384 70 53.8256 70 56C70 58.1744 70 59.2616 69.6448 60.1192C69.1711 61.2627 68.2627 62.1711 67.1192 62.6448C66.2616 63 65.1744 63 63 63H49C46.8256 63 45.7384 63 44.8808 62.6448C43.7373 62.1711 42.8289 61.2627 42.3552 60.1192C42 59.2616 42 58.1744 42 56Z",
    stroke: "#29286A",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6654 32.668V60.668C95.6654 78.2671 95.6654 87.0666 90.198 92.534C84.7307 98.0013 75.9311 98.0013 58.332 98.0013H53.6654C36.0663 98.0013 27.2667 98.0013 21.7994 92.534C16.332 87.0666 16.332 78.2671 16.332 60.668V32.668",
    stroke: "#29286A",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33203 23.3333C9.33203 18.9336 9.33203 16.7337 10.6989 15.3668C12.0657 14 14.2656 14 18.6654 14H93.332C97.7318 14 99.9317 14 101.299 15.3668C102.665 16.7337 102.665 18.9336 102.665 23.3333C102.665 27.7331 102.665 29.933 101.299 31.2998C99.9317 32.6667 97.7318 32.6667 93.332 32.6667H18.6654C14.2656 32.6667 12.0657 32.6667 10.6989 31.2998C9.33203 29.933 9.33203 27.7331 9.33203 23.3333Z",
    stroke: "#29286A",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/Archive.be115801f20a573e0c35fe18296550a3.svg";
export { ForwardRef as ReactComponent };